import { getAuthToken } from '@features/authentication/utilities/authToken';

import {
    LoginBody,
    LoginResponse,
    VerifyMfaBody,
    VerifyMfaResponse,
} from '../types/authentication';

async function readResponse<T>(response: Response): Promise<{ response: Response; body: T }> {
    const text = await response.text();
    let body = {} as T;
    if (text) {
        try {
            body = JSON.parse(text);
        } catch {
            if (response.ok) {
                console.error(
                    "[authentication|readReaspons]: Couldn't proccess JSON body of succesfull response",
                );
                body = {
                    errors: [{ message: 'Unexpected login response.' }],
                } as T;
            } else {
                body = {
                    errors: [{ message: text }],
                } as T;
            }
        }
    }
    return { response, body };
}

const authenticationService = {
    async login(loginId: string, password: string): Promise<LoginResponse> {
        const response = await fetch('/auth/login', {
            method: 'POST',
            body: JSON.stringify({ loginId, password }),
        });
        return readResponse<LoginBody>(response);
    },
    async verifyMfa(twoFactorId: string, mfaCode: string): Promise<VerifyMfaResponse> {
        const response = await fetch('/auth/mfa-verify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ twoFactorId, mfaCode }),
        });
        return readResponse<VerifyMfaBody>(response);
    },
    async logout() {
        const response = await fetch('/auth/logout', {
            method: 'POST',
        });
        const body = await response.json();

        return { response, body };
    },
    async verify(): Promise<Response> {
        const response = await fetch('/auth/verify', {
            method: 'GET',
        });
        return response;
    },
    hasRole(role: OneOrMany<string>): boolean {
        const authToken = getAuthToken();
        if (authToken) {
            try {
                const jwtPayload = authToken.split('.')[1];
                const decodedPayload = atob(jwtPayload);
                const { roles } = JSON.parse(decodedPayload);

                if (!Array.isArray(role)) return roles.includes(role);

                return !role.find((str) => !roles.includes(str));
            } catch (e) {
                return false;
            }
        }
        return false;
    },
};

export default authenticationService;
